module.exports = __webpack_public_path__ + "static/media/M006-account.f3ec56af.svg";